export function formatCurrency(value: number | null | undefined) {
  const amount = Number(value ?? 0)
  return `₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`
}

function createInrFormatter(minimumFractionDigits: number) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits,
    maximumFractionDigits: 2,
  })
}

const inrFormatter = createInrFormatter(0)
const inrFixedFormatter = createInrFormatter(2)

export function formatInr(n: number) {
  return inrFormatter.format(n || 0)
}

export function formatInrFixed(n: number) {
  return inrFixedFormatter.format(n || 0)
}
